export const BACKEND_URL = "https://byfatsy.sophic-team.com/fatsy";